<script setup lang="ts">
import PdfPreview from '~/components/input/FileUpload/PdfPreview.vue'

interface Props {
  isOpen: boolean
  title: string
  url: string
  filePath?: string
  mimeType?: string
  modalId?: string
}

const props = defineProps<Props>()

const emit = defineEmits<{
  close: []
}>()

const isPdf = computed(() => {
  if (props.mimeType === 'application/pdf')
    return true
  const path = (props.filePath || props.url || '').split('?')[0].toLowerCase()
  return path.endsWith('.pdf')
})

const previewUrl = computed(() => {
  if (!props.url)
    return ''
  return props.url
})

const pdfViewerUrl = computed(() => {
  if (!props.url || !isPdf.value)
    return ''
  return props.url
})

function closeModal() {
  emit('close')
}
</script>

<template>
  <PdfPreview
    v-if="pdfViewerUrl"
    :is-open="isOpen"
    :title="title"
    :pdf-url="pdfViewerUrl"
    :modal-id="modalId"
    @close="closeModal"
  />
  <SolModal
    v-else-if="previewUrl"
    :id="modalId ?? 'document-image-preview'"
    :is-open="isOpen"
    :title="title"
    :size="{
      desktop: 'large',
      mobile: 'full',
    }"
    @close="closeModal"
  >
    <template #default>
      <div class="document-image-preview">
        <img :src="previewUrl" :alt="title">
      </div>
    </template>
  </SolModal>
</template>

<style scoped lang="scss">
.document-image-preview {
  @apply flex items-center justify-center;
  @apply w-full;

  img {
    @apply max-w-full max-h-[70vh] rounded-md;
    object-fit: contain;
  }
}
</style>
